module.exports = __webpack_public_path__ + "img/11.9ac79a5f.jpg";